export default __webpack_public_path__ + "594fcf283b545e8a5bdc1dab2e545fb8.otf";